export default "__VITE_ASSET__0fdab09f__"